// Shared by journey tracking and the provider landing experiment. Keep the
// existing first-party identifier and storage key; do not create a second id.
export function getOrCreateJourneyAnonymousId() {
  let anonId = localStorage.getItem('rxr_anonymous_id');
  if (!anonId) {
    anonId = `anon_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem('rxr_anonymous_id', anonId);
  }
  return anonId;
}
